import React from 'react';

export interface RelatedItem {
  '@id': string;
  title: string;
}

export const InternalLayoutContext = React.createContext<{
  title: string;
  description?: string;
  relatedItems?: RelatedItem[];
  /**
   * Campo `largura_total` da página (behavior
   * `ministerio.publico.federal.largura_pagina`, só no tipo `Document`).
   * Quem consome é `contentAreaClassName.ts`; as views de outros tipos não
   * passam nada e seguem com a largura derivada dos sinais estruturais.
   */
  larguraTotal?: boolean;
  /**
   * Campo `ocultar_titulo` da página (behavior
   * `ministerio.publico.federal.ocultar_titulo`, só no tipo `Document`).
   * Quem consome é o `PageTitle`, que passa o `h1` para `sr-only`.
   */
  ocultarTitulo?: boolean;
  /** `review_state` do conteúdo; colore a linha do `PageTitle` para o editor. */
  reviewState?: string;
}>({
  title: '',
  description: undefined,
  relatedItems: undefined,
  larguraTotal: false,
  ocultarTitulo: false,
});

export const InternalLayoutProvider = ({
  children,
  title,
  description,
  relatedItems,
  larguraTotal = false,
  ocultarTitulo = false,
  reviewState,
}: {
  children: React.ReactNode;
  title: string;
  description?: string;
  relatedItems?: RelatedItem[];
  larguraTotal?: boolean;
  ocultarTitulo?: boolean;
  reviewState?: string;
}) => {
  return (
    <InternalLayoutContext.Provider
      value={{
        title,
        description,
        relatedItems,
        larguraTotal,
        ocultarTitulo,
        reviewState,
      }}
    >
      {children}
    </InternalLayoutContext.Provider>
  );
};

export default InternalLayoutProvider;
